// extracted by mini-css-extract-plugin
export default {"success":"Success_success__t84Jv","checkmark":"Success_checkmark__CH8Fi","btn":"Success_btn__FSwT+"};